import { useEffect } from "react";
import { LoadingScreen } from "../../components";
import { useNavigate } from "react-router-dom";
import { useAuthChecker } from "../../Context";
import { LOGIN } from "../../Constant";

export const LogingSuccessPage = () => {
  const { user, isAuthenticated, userPermission } = useAuthChecker();

  const navigate = useNavigate();
  const messageQueue = [
    { message: "Waiting...", duration: 900 },
    { message: "Your app is setting up...", duration: 1100 },
    { message: "Almost there... Just a moment!", duration: 1500 },
    { message: "Here we go.....", duration: 500 },
  ];

  useEffect(() => {
    if (!userPermission || userPermission.length === 0) return;

    const availableFirstPermission =
      userPermission?.[0]?.features?.[0]?.navigation;

    if (isAuthenticated && availableFirstPermission) {
      setTimeout(() => {
        navigate(`../admin/${availableFirstPermission}`);
      }, 4100);
    } else {
      navigate(LOGIN);
    }
  }, [user, isAuthenticated, userPermission]);

  return (
    <>
      <LoadingScreen messageQueue={messageQueue} />
    </>
  );
};
